import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Remove the fallback SEO tags from public/index.html before React renders.
 *
 * Those tags exist for crawlers that do not execute JavaScript (social scrapers,
 * AI crawlers). Once JS runs, <Seo /> renders accurate per-route equivalents,
 * and React 19 hoists them into <head> during the commit phase.
 *
 * They MUST be removed, and removed here rather than in an effect:
 *   1. Two <title> elements would coexist, and browsers plus document.title use
 *      the FIRST one — so the generic fallback title would win on every route.
 *   2. useAnalytics reads document.title in an effect. Effects run after commit,
 *      so stripping in an effect would let GA log the stale title. Doing it
 *      before render means the correct title is always in place first.
 *
 * Runs once, before ReactDOM.createRoot().render().
 */
function stripDefaultMeta() {
  document
    .querySelectorAll('head [data-default="true"]')
    .forEach((el) => el.remove());
}

stripDefaultMeta();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
